import { FormattedMessage } from 'react-intl';
import ShieldCheckIcon from '@/shared/components/ShieldCheckIcon';

interface Props {
  onCreateClick: () => void;
}

const TRUST_ITEMS = [
  'accounts.list.emptyTrustEncrypted',
  'accounts.list.emptyTrustReadOnly',
  'accounts.list.emptyTrustRemovable',
] as const;

export default function EmptyState({ onCreateClick }: Props) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/50 px-6 py-10 text-center">
      <h3 className="text-lg font-semibold text-slate-900">
        <FormattedMessage id="accounts.list.emptyHeadline" />
      </h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-slate-500">
        <FormattedMessage id="accounts.list.emptyDescription" />
      </p>

      <button
        type="button"
        onClick={onCreateClick}
        className="mt-6 inline-flex items-center justify-center rounded-2xl bg-gradient-to-r from-brand-600 to-accent-500 px-6 py-3 text-base font-semibold text-white shadow-xl shadow-brand-200/60 transition hover:from-brand-500 hover:to-accent-400 focus:outline-none focus:ring-2 focus:ring-brand-300"
      >
        <FormattedMessage id="accounts.list.emptyAction" />
      </button>

      <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-400">
        {TRUST_ITEMS.map((id) => (
          <li key={id} className="flex items-center gap-1.5">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent-600" />
            <FormattedMessage id={id} />
          </li>
        ))}
      </ul>
    </div>
  );
}
